import React, {Component} from 'react'
import {translate} from 'react-i18next'

export default translate()(class extends Component {
  constructor (props) {
    super()
    this.state = {
      language: props.i18n.language
    }
  }

  componentWillReceiveProps (props) {
    this.setState({
      language: props.i18n.language
    })
  }

  change (lng) {
    return event => this.props.i18n.changeLanguage(lng)
  }

  render () {
    const jpClassName =
      this.state.language === 'ja' ? '' : 'lngSwitcher-unactivate'
    const enClassName =
      this.state.language === 'en' ? '' : 'lngSwitcher-unactivate'
    return (
      <div id="lngSwitcher">
        <div className={jpClassName} onClick={this.change.bind(this)('ja')}>
          JP
        </div>
        <div className={enClassName} onClick={this.change.bind(this)('en')}>
          EN
        </div>
      </div>
    )
  }
})



// WEBPACK FOOTER //
// ./src/components/LngSwitcher.js